import { bulkSendUsageMetrics } from 'api/metrics'
import store from 'config/store'
import { pathOr } from 'ramda'
import { DRIFT_SESSION_ID } from 'shared/constants/session'
import { isMobile, uuid, warn } from 'utils'
import { getBrowserContext } from 'utils/context'
import EventBuffer from 'utils/eventBuffer'
import { sessionStore } from 'utils/storage'


const MAX_BUFFER_SIZE = 100
const BUFFER_TIME_IN_MS = 2000

class UsageMetricEventBuffer extends EventBuffer {
  constructor() {
    super(BUFFER_TIME_IN_MS)
  }

  _publishBuffer = async () => {
    if (!this._events.length) {
      Promise.reject(undefined)
    }

    try {
      const hydratedEvents = await this._hydrateEvents()

      await bulkSendUsageMetrics(hydratedEvents)
      this._resetBuffer()
    } catch(err) {
      if (this._events.length >= MAX_BUFFER_SIZE) {
        this._resetBuffer()
      }
      warn(['Failed to send bulk metrics', err])
    }
  }

  _hydrateEvents = async () => {
    const { data:sessionId } = await sessionStore.get(DRIFT_SESSION_ID) || {}
    const { session, embed, metrics } = store.getState()

    const endUserCountry = pathOr('', ['geo', 'country'], session)
    const userAgent = pathOr('', ['context', 'userAgent'], session)
    const isMobileEvent = isMobile(userAgent)
    const browserContext = getBrowserContext()
    const totalLoadSize = metrics.loadCostInBytes

    const hydratedEvents = this._events.map<Record<string, any>>(event => {
      if (event.eventName === 'loaded') {
        event.attributes.loadSizeInBytes = totalLoadSize
      }

      return {
        eventName: `[V2] - ${event.eventName}`,
        embedId: embed.id,
        sessionId,
        instanceId: session.instanceId,
        attributes: {
          ...event.attributes,
          isMobile: isMobileEvent
        }
      }
    })

    return Promise.resolve({
      id: uuid(),
      events: hydratedEvents,
      timestamp: Date.now(),
      context: {
        country: endUserCountry,
        locale: browserContext.locale,
        timezone: browserContext.timezone,
        url: browserContext.url
      }
    })
  }
}

export default new UsageMetricEventBuffer()
